import { render, staticRenderFns } from "./DataInputDate.vue?vue&type=template&id=90807820&scoped=true&"
import script from "./DataInputDate.vue?vue&type=script&lang=js&"
export * from "./DataInputDate.vue?vue&type=script&lang=js&"
import style0 from "./DataInputDate.vue?vue&type=style&index=0&id=90807820&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90807820",
  null
  
)

export default component.exports